// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__NP3lB","title":"AfterFrontImage_title__lbdDr"};